import { MenuItem } from "@mui/material";

import { useAnalytics } from "@/providers";
import { StyleOutlinedIcon } from "@/shared/foundation/icons/mui";

interface ViewTagsAndMetadataProps {
  onClick: () => void;
}

export function ViewTagsAndMetadata({ onClick }: ViewTagsAndMetadataProps) {
  const { trackEvent } = useAnalytics();

  return (
    <MenuItem
      onClick={function openTagsAndMetadata() {
        trackEvent("FileDetailsClicked");
        onClick();
      }}
    >
      <StyleOutlinedIcon fontSize="small" />
      View file details
    </MenuItem>
  );
}
